import { lazy } from 'react';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';

import { HumanTaskAppVariant } from './Agents/Flows/HumanTasks/types';
import { NotFoundPage } from './NotFoundPage';
import { LazyLoader } from '../components/LazyLoader';

const HumanTaskRoutes = lazy(() =>
  import('./Agents/Flows/HumanTasks/Routes').then((module) => ({ default: module.HumanTaskRoutes }))
);

export function CopilotRoutes() {
  const match = useRouteMatch();
  const { pathname, search } = useLocation();
  return (
    <LazyLoader>
      <Switch>
        {/**
         * When clicking a link that goes up a level, such as `to="..", the browser will append a trailing slash
         * This breaks code like `${match.path}/flows/definitions/:id` because will end up with a double slash.
         * This solution works well (and we've been using it in FlowBuilder since 2024-09-15 in #52668)
         * The Redirect replaces the url with the same url but without the trailing slash. It also preserves the search params.
         * https://jasonwatmore.com/post/2020/03/26/react-router-relative-links-example
         */}
        <Redirect
          from="/:url*(/+)"
          to={{
            pathname: pathname.slice(0, -1),
            search,
          }}
        />
        <Route path={`${match.path}/humanTasks`}>
          <HumanTaskRoutes appVariant={HumanTaskAppVariant.CopilotApp} />
        </Route>
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </LazyLoader>
  );
}
